/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useGetContext} from "./RouteHooks";
import {usePrimeCache} from "./ServiceHooks";
import {service as ConservationActionTypeService} from "../Services/ConservationActionTypeService";
import {useSafeState} from "./useSafeState";
import {service as ConservationActionService} from "../Services/ConservationActionService";
import {useEffect} from "react";

export const useValidConservationActionTypes = () => {
    
    const getContext = useGetContext();
    const { project: projectId } = getContext();
    
    usePrimeCache([ConservationActionTypeService]);
    
    const [childConservationActions, setChildConservationActions] = useSafeState(null);
    const conservationActionTypes = ConservationActionTypeService.CachedValues()?.result;
    
    const loadChildConservationActions = async () => {
        setChildConservationActions(null);
        if (projectId) {
            try {
                const { result: existingConservationActions = [] } =
                    (await ConservationActionService.GetConservationActionsForProjectId(projectId));
                setChildConservationActions(existingConservationActions);
            } catch (e) {
                setChildConservationActions(null);
            }
        }
    };
    
    useEffect(() => {
        void loadChildConservationActions();
    }, [projectId]);
    
    
    const isValid = (conservationActionType) => {
        
        // some Conservation Action Types are not creatable from the UI
        if (!conservationActionType.isCreatable) {
            return false;
        }
        
        // if we didn't load existing Conservation Actions yet, assume it's valid
        if (childConservationActions === null) {
            return true;
        }
        
        //if we have one of this type already it's not creatable.
        return !childConservationActions.some((existingConservationAction) =>
            existingConservationAction.conservationActionTypeId === conservationActionType.conservationActionTypeId
        );
    };
    
    return conservationActionTypes?.filter?.(isValid) ?? null;
}
